<!-- 
	This is the dashboard page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
	<div>
		<aclTable ref="aclTable" class="mb-24" />
		<uhcTable ref="uhcTable" class="mb-24" />
	</div>
</template>

<script>
	// import axios from 'axios';
	import aclTable from '../components/Inventories/ACLTable';
	import uhcTable from '../components/Inventories/UHCTable';
	import tools from "../utils/tools";

	export default ({
		//
		//
		//
		components: {
			aclTable,
			uhcTable,
		},
		//
		//
		//
		data() {
			return {
				
			}
		},
		//
		//
		//
		beforeCreate() {
			if (!tools.isLogin()) this.$router.push("/login");
		},
		//
		//
		//
		created() {

		},
		//
		//
		//
		beforeMounted() {

		},
		//
		//
		//
		mounted() {
			if(localStorage.getItem('accessToken') === null) {
				return;
			}

			this.$refs.uhcTable.setQuery("email=" + localStorage.getItem("email"));
			this.$refs.uhcTable.requestData();
		},
		//
		//
		//
		beforeUpdated() {

		},
		//
		//
		//
		updated() {

		},
		//
		//
		//
		beforeDestroy() {

		},
		//
		//
		//
		destroyed() {

		},
		//
		//
		//
		methods: {
			
		},
	})

</script>

<style lang="scss">
</style>